/** Fired by the API client whenever a request is rejected with 402. */
export const BILLING_REQUIRED_EVENT = 'seated:billing-required'
